module.exports = __webpack_public_path__ + "static/media/project-thumbnail03.133e4bf4.jpg";